import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  DialogVisible: false,
  fromActionButton: false,
};

const leadJobPopUpSlice = createSlice({
  name: 'leadJobDialog',
  initialState: initialState,
  reducers: {
    setLeadJobPopUp(state, { payload }) {
      state.DialogVisible = Object.prototype.hasOwnProperty.call(
        payload,
        'DialogVisible'
      )
        ? payload.DialogVisible
        : state.DialogVisible;
      state.fromActionButton = Object.prototype.hasOwnProperty.call(
        payload,
        'fromActionButton'
      )
        ? payload.fromActionButton
        : state.fromActionButton;
    },
  },
});

export const { setLeadJobPopUp } = leadJobPopUpSlice.actions;

export const leadJobPopUpReducer = leadJobPopUpSlice.reducer;
